export default {"src":"/_next/static/media/skillz_powered_logo.e808cec5.svg","height":73,"width":103,"blurWidth":0,"blurHeight":0};